import { default as course } from './course/routes'
import { default as courseCluster } from './cluster/routes'

export default [
    ...course,
    ...courseCluster
]